<template>
  <div class="big_box" v-loading="loading" @click.stop>
    <div class="area_header">
      <el-input size="mini" v-model="value" @input="inputFouce" :placeholder="$t('m.search_for')" prefix-icon="el-icon-search" clearable></el-input>
    </div>
    <div class="countryList">
      <ul>
        <li class="fc-flex fc-flex-vcenter fc-pointer" v-for="item in countryArrSel" :key="item.id" @click="selCountryInfo(item)" >
          <img class="flag" :src="item.logo">
          <div class="fc-flex1 con">{{item.content}}</div>
          <span class="code">{{hideCode?null:('+' + item.countryNum)}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

import { anchorCountryArrAjax } from "@/api/common";
var _self;
export default {
  name: "SelArea",
  components: {},
  props:{
    hideCode:false,
    countryAll:'',
  },
  data() {
    return {
      loading:false,
      value: "",
      countryArr: [],
      countryArrSel: [],
      countryList: [],
    };
  },
  filters: {},
  watch: {},
  mounted() {
    _self = this;
    if(this.countryAll){
      this.countryArr = this.countryArrSel = this.countryAll;
    }else if(_self.$store.state.countryArr){
      // 如果store已存在，直接取用，避免重复请求
      this.countryArr = this.countryArrSel = _self.$store.state.countryArr;
    }else{
      this.getCountryListCode();
    }
    
  },
  methods: {
    inputFouce() {
      //监听键入值变化
      if (_self.value) {
        let searchTxt = _self.value.toLowerCase();//转为小写
        _self.countryArrSel = [];
        _self.countryArr.forEach((item) => {
          let a = item.countryNum + '';
          let b = item.content.toLowerCase();
          if (b.indexOf(searchTxt) > -1) {
            _self.countryArrSel.push(item);
          }else if(a.indexOf(searchTxt) > -1&&!this.hideCode){
            _self.countryArrSel.push(item);
          }
        });
      } else {
        _self.countryArrSel = _self.countryArr;
      }
    },

    selCountryInfo(e) {
      //localStorage.setItem('selcountry', JSON.stringify(e))
      this.$emit('countryOption', e)
    },
    getCountryListCode() {
      this.loading=true;
      anchorCountryArrAjax().then(({ data }) => {
        console.log(data)
        this.loading=false;
        console.log(data);
        if (data.code == 1) {
          _self.countryArr = _self.countryArrSel = data.data;
          // 更新到store一份，刷新页面前，如果该数据已存在，就不会重复获取
          _self.$store.state.countryArr=data.data;
        }
      })
      .catch((error) => {
        this.loading=false;
        console.log(error);
        _self.countryArr = _self.countryArrSel = error.data;
      });
      
    },
  },
};
</script>

<style scoped lang="less">
.big_box {
  height: 100%;
  padding-top: 60px;
  box-sizing: border-box;
}
.van-icon__image {
  float: left;
  margin-top: 0.3em;
  background-color: #eee;
  border-radius: 50%;
}
.area_header {
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 99;
  padding: 10px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebedf0;
}

.vant_search .van-search__content {
  border-radius: 0.8rem;
}
.selcountry_title {
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  background-color: #fff;
  text-align: center;
}
.countryList {
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}
.van-cell__left-icon{
  margin: 0 4px;
}
.ar_class{

 .van-cell__value{
    text-align: left;
  }
}
.countryList{
  ul{
    padding: 0;
    margin: 0;
    li{
      padding: 10px 16px;
      position: relative;
      &::after{
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 16px;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
      }
    }
  }
  .flag{
    width: 16px;
    height: 16px;
  }
  .con{
    margin: 0 10px;
  }
  .code{
    color: #999;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelArea.vue